/*
* @date 2018-04-08
* @author hyt
*
* 初始化发布页和详情页的dom结构
*/
// import Decimal from "decimal.js";
import Decimal from "./../../../utils/Decimal";
// import CalculateMode from "./../../../common/calculateMode.js";
import newYue from "./newYue.js";
import urlParam from './../../../utils/fun.js';
import $event from './../../../common/event.js';
import $jsonp from './../../../common/ajax.js'
import getPriceRequest from './../../../common/getPriceRequest.js'

function IssueDetail() {
    this.couponPrice = 0;
    // 优惠券
    this.ticket = {price: 0, coupon: '', durationHour: ''};
    // 优惠券对象
    this.coupon = null;
    // 优惠券参数
    this.couponParam = {};
    // 自动续费
    // this.auto = 0;
    // 频道
    this.channels = {};

    // 请求价格接口时需要传的pageList
    this.pageList = '';
    // 时间
    // this.time = '';

    // 用于修改置顶后的异步回调
    // this.reviseTop = "";
    this.vipDiscount = false;

    this.isPackage = true;
    this.quit = true;
    // 埋点参数
    this.trackLogParam = '';
    // 引入计算模块对象
    this.calculateMode = null;

    // 账户余额总和
    this.accountBalance = 0;

    // 点击添加优惠券的参数
    this.promptyCitysed = [];
    this.promptyCateed = [];
    this.pricePerHour = [];
    this.pingdao = [];
    // 置顶页面数据
    this.pingdaoName = [];

    // 详情页余额足够的url
    this.enoughUrl = '';
}



IssueDetail.prototype = {

    // 初始化，主入口
    init: function () {
        this.param = window.commercial;
        this.type = this.param.common.commonType;
        // 发布成功页
        if (this.type == 11) {
            $('#commercial').html('<div id="prompty_price"></div>');
            // 发布成功页直接调用置顶请求
            this.submit();
        } else {
            this.getInitPage();
        }

        if (this.type == 10) {
            window.commercial.selected = false; // 发布页默认不选中
        } else {
            window.commercial.selected = true; //
        }
    },

    // 处理发布页和详情页共同的“置顶页面将在【xx-xx】等Y个页面展示”的信息
    renderPageTip: function () {
        var page = '';
        if (this.pingdaoName.length > 3) {
            page = this.pingdaoName.slice(0, 3).join(',') + "等" + this.pingdaoName.length;
        } else {
            page = this.pingdaoName.join(',') + this.pingdaoName.length;
        }
        return page;
    },

    // 循环天数方法
    loopStocks: function (data, type) {
        var _this = this;
        var arr = [];
        $.each(data.stocks, function (index, item) {
            if (!item.disabled) {
                _this.quit = false;
            }
            var tipSmSG = '';
            if (_this.isPackage) {
                tipSmSG = '置顶已售罄,无法购买';
            } else {
                tipSmSG = (item.msg.split(",").length > 3 ? (item.msg.split(",").slice(0, 3).join(",") + "等") : item.msg) + "页面置顶已卖满,无法购买";
            }
            var showDay = new Decimal(item.hours).div(24).toNumber() >= 1 ? new Decimal(item.hours).div(24).toString() + '天' : item.hours + '时';
            // 详情页数字和天时字体大小不同，需要分开渲染
            var showDayNum = new Decimal(item.hours).div(24).toNumber() >= 1 ? new Decimal(item.hours).div(24).toString() : item.hours;
            var showDayType = new Decimal(item.hours).div(24).toNumber() >= 1 ? '天' : '时';
            var showDiscount = item.discount >= 1 ? '' : new Decimal(item.discount).mul(100).toString() + "折";
            if (type == 'detail') {
                // 如果是详情页，返回以下dom结构
                // var showPrice = _this.calculateMode.calculatePrices(item.hours, item.discount, _this.ticket);

                // TODO: 传进来的参数中有price，用来渲染价格相关
                // data.price
                arr.push('\
					<li class="', (item.defaultDays && !item.disabled) ? 'commercial_item_selected' : '', item.disabled ? ' zl_time_quit' : '', '" data-hours="', item.hours, '" data-discount="', item.discount, '">\
						<div class="commercial_detail_time_disprice">\
							<div class=""><em>', showDayNum, '</em>', showDayType, '</div>\
							<div class="cd_cur_disprice">￥', item.hidden_totalPrice, '</div>\
						</div>\
						<span class="commercial_detail_discount">', showDiscount, '</span>\
						<p class="commercial_time_notice">', tipSmSG, '</p>\
					</li>')
            } else {
                // 如果是发布页，返回以下dom结构
                arr.push('\
					<li class="', (item.defaultDays && !item.disabled) ? 'commercial_item_selected' : '', item.disabled ? ' zl_time_quit' : '', '" data-hours="', item.hours, '" data-discount="', item.discount, '">', showDay, '\
						<span class="commercial_issue_discount">', showDiscount, '</span>\
						<p class="commercial_time_notice">', tipSmSG, '</p>\
					</li>')
            }
        })
        return arr.join('');
    },

    // 构建发布页dom结构
    renderIssueDom: function (data) {
        var _this = this;
        var page = _this.renderPageTip();
        var str = this.loopStocks(data, 'issue');
        var issue = `
			<div class="commercial_content commercial_issue" id="prompty_time">
				<div class="commercial_issue_profit">马上使用<span>58置顶推广</span> ，帖子效果可提升约<i> 3~5</i>倍！<span>效果预览</span></div>
				<div class="commercial_issue_content">
					<div class="commercial_issue_info">
						<div class="commercial_issue_page clearfix">
						    <div class="commercial_issue_button" id="commercial_issue_select" data-check="false"></div>
							<h1>置顶推广</h1>
							${this.isPackage ? '' : `<p>置顶页面<span>置顶将在${page}个页面展示</span></p>`}
						</div>
						<div class="commercial_issue_price clearfix">
							<p class="fl">总计金额：<span id="commercial_issue_payPrice">0.00</span>&nbsp;元</p>
							${this.vipDiscount ? '<span class="commercial_issue_vip fl">会员专享折扣</span>' : ''}
						</div>
						<ul class="commercial_issue_time commercial_top_time clearfix zl_common_allHour" data-allHours="${data.maxSaleHour}">${str}</ul>
					</div>
					<div class="commercial_issue_title"></div>
				</div>
				<div class="commercial_issue_perfer clearfix">
					<p class="commercial_issue_ticket fl"><span>券</span>添加优惠券</p>
					<p class="commercial_issue_autopay fl">
						<span class="commercial_auto" data-check="false">
							<i></i>
							<span class="commercial_issue_autotitle">自动续费</span>
							<span class="commercial_issue_autodiscount">9.8折</span>
						</span>
						<span class="commercial_issue_autotip">（勾选后系统将在置顶到期时自动帮您续费，享<span>9.8折</span>优惠，可在管理置顶随时取消自动续费）</span>
					</p>
					<p class="commercial_issue_actualpay">
					应付<span class="commercial_payPrice">0.00元</span>
					<span class="hyt_fc_aftervip">会员专享价：<em><i  class="hyt_fc_afvprice">129.00</i>元</em>   会员咨询：400-640-1189</span>
					</p>
				</div>
			</div>`;

        return issue;
    },

    // 构建详情页dom结构
    renderDetailDom: function (data) {
        var _this = this;
        // 价格之后操作
        var page = _this.renderPageTip();
        var str = this.loopStocks(data, 'detail');
        var detail = `
			<div id="commercial">
			 	<div class="commercial_content">
				 	<div class="commercial_transparent_bg"></div>
			 		<div class="commercial_detail" id="prompty_time">
			 			<div class="commercial_min"></div>
			 			<div class="commercial_detail_content">
							<div class="commercial_detail_img">
								<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIYAAABsCAYAAACvpsp1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpEQjVCNDAzNzYzMUIxMUU0OUU1NDlDREY4NUU5MzEzRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpEQjVCNDAzODYzMUIxMUU0OUU1NDlDREY4NUU5MzEzRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkRCNUI0MDM1NjMxQjExRTQ5RTU0OUNERjg1RTkzMTNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkRCNUI0MDM2NjMxQjExRTQ5RTU0OUNERjg1RTkzMTNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+FECwAQAAKE5JREFUeNrsfQmUHNV57n+rqpfpmemZkYRkEGCQ2Cx2YzDYIRhs/IRjJbGdeCGEYFvs5hGc5PnYWR7YDl6xAS8vjvEzEIfHORgfAggTTODYDuCHLEwcJAHaJbSPZu+9qu777617q27tVd3SQN6Z4jTd6um/tvvV96/3v6R9zdvAtxlkGfQVVtISuQR07diGbZf6NA263VAe5uRzybfAsjeTFn0cGp27Ct96fh28DhtRgFGEweI3aEW/Fj9rYFtQNy2o9HBT6jaT1+fkc40IwRcbAZ2Byq606Pdhun1T4burG7MJDM0FxUhp1WQRrgfT1PCFoDBzg2ISZXq5KXPyKE8pgE2h3m5Bn21rtE+/GoZLj3auPbs4m8AwKPv/YPGbkxp9TxUonheelOWAgtpm5h1NdCwYLuhcpm7hTdH1Oflu5VH9VHSDjwV7SGnRuIggm+PPPjVrqqR1w9knT1YL/1GlNjsrZIoOVBiV4ckhfB0Ep10UnvywYfDPNbwp/Xq+J2VOXpHH+96PoADG1kTjKoW/FwoWGWueXrzz+bWzwhjNoraySojOkFnrtKEfEBBWhwODIlDSgDHeMWGkgOg2W+5NoZ3sJzAnH5BnADE1Bxh6AV8MJOyFOy4XVqLITbMCjFJJWw5mG2qtBvRTpC2TgQIpEHUkI4wkYIwhmOaxC2mbMIMXNcCeFCv7XZmTj5DHe0+F8QlaB4hRYKPEjVJaMJbPGjDwJJZwUNgdsDstvDABihQ1MoZIn8eQbnsXlUenzsknyDPPBL8DzcLvLCBsHNh3JWPJrBmfdbNdZKCgDBSMLaiVqj7kRbHNRXqObU4+RZ7ff8c7YZ8pxwoCo1A82J4JcQ4U4a5WEAhcfTCmmAPFG0uejQUbE0uo+BxqKm6r2WS4RT+sK6EKQVLE99IoOyjTa0hZVKAz7nVAGkr4eVoaWgm/n5M/CPJsTNjY4BiNt1q9guIofHsGX30B1ogIcDF7QtoUc0/qG1SeIijaMKz1BIrT0MV5jsDAMQVyc5sFJNydRwKD0xVkMjTnBvV1km93YMTQM8WUIkFhkQuBVn5JYGQxBWujBsvaMfaGGhJPD2L1clFz8gdJHseIxTlyg8IkHwUo/yuBRVX0i/Gb5qvCpiC33HILkZsCDv4yKPWM4KRtBtXNAPrWXYJ2Tr5XeQTFYM7cVa1D/oKQo76uwbGoN9bjsafYsL/MgHDzzTeTtWvXkki9FbRMk05qoIcs45z87MrX2oTU2uU7NXIGguJU9Hp/i6DYz/+Gu9rIGAGBAfv375cMoals4QS4UsiipljP3em3OfnZlJ9paSzW8SNdO/OPNVgKFjyNspPu39st2MAG/6yzztIEMKgSz3APY/idoyBSbdSJWrqeiUX6nPzBk0/X9zNNbQjfHi4Yn/xdjRwNHft/ocQeXyhr5w5gNoY2ODior1mzhipag6qeiuG3ni00dPTASWVxppz/j3VslNdc+QrKW8rF0JgYjtxklpFFU3iWEXVqm9ruLRn6219A4dhlmW/sQI/BoG7l937rBphaczdUtUJWbd3T/ee/r2tHEm3xkwXjihOZkdkyb0UDs+WPbxI4cMYyTh/axo0bSeDkbPWXrioZx5MaKTiUJU8qDeeTA0dA8bjz+eemTaFPI8DKjDo42gYaus0cN7OF8hWUZ3azifJFlFfjfM0X7uUDVYA3/uacvwZNaoGJd3GAGDgCJFGmm/vvgqKmnQKk/K8FY+URLLXbsX/IlAbIFItUFvjvVwQY9FarpUWExV21wsNwYyYilfvJnvWc5awYKBbe8K1ZudlbP34v/FfZdAXUHWS8SRysQQSHEcMeme5/jCaZmdEu0LQljxZLtw3Y9svQNr/ECjaDTOEAtgOb2OkxcPT39xtoY9AAW7jo1Vjl0Dxd78r61WbzblP4r7MF4to2PqqTdgda1IoOfhnd3f+Z6cJHdP1dT5ZK3x4wzR9Du/NZPF5bef6Jd9soNzw5MIaHh42xsTEt4I34x3ZI0Fc3sf+WBXNbHmOSmlBjNS/i/o11kTtx9zWl3aRpp91fKFxvdDr3AwOG7wfUC2hKO256mruqeqVSMSilicAw3OBLF2HeYX12H8Ldt5zn/ruBerhPGGfMQGU6PZHdqsfCm+98MfR9fd1q2PGVi1Llg1ve47tyyBoWMnfb1GB+FxHR6QmNDeI3CsU/+fNi+XPQbv89qoj7/MNLIz7j++aNsJUBw7IsjTposQOgcLnGqFnM+s9XZCLL0eyZCWhuWQd6BNtHfS5HeBSdiVGwxvflGpS68HjyDEpJGMmhOMGGF3KDopvj+4x2kwGBomGqQ5Pd/6xxCpTRYPjBQvn6DxjGRdCs/QGqqY1+EATNSSJUCqH0jm/CFvaMlMtlfe/evVaS0jYqOaxfVydKpL+8Cuwv/NR1O5mb6ZQQs3f5Ajedf8zdk2F6Xf0EjP/zNTmeVPR+dMKPwbyfAnE+pwLjLedFft9e94tM8r0e3/WuhDxz40etFszTMtbelCmQP90FheJVH9DRCWk2bgTb3uh5HZDMGLZNXlv1KGVPv1ar1SDNtDXy2HXjik6sBeiP1Snyc6BelEQe044vFMr5pKJLqxPxpDoubdattPj40Hd2sw6tVx6ZleOroOLuOd6OEsrPoMfSh8NQIgmqZMgGbeUklJbeBrpxFjLF5cgUm7y/RzFGACBoeG5m/0L7QqvX68Ff0XDkM1tQDcZNBIXhBErdGkWqnpt3FkQAhCjgYPSbaMGnDYqIc3DrWg5KDqyVlpwcZovdWzPvo9fjN0Sch8m0UJ6Bggj5Jj7IJkH1RAohK5C8yQLjmsOgdPhdeL8PQH3yAvzScm0K+TDGAkR8bjkeCRHgAAGO2BExsoxLkCmidSIR50WdYI44KR6wMVlZvN61JyoNPSriAgWST/1Zh58LerkS3u+GFzPtp9fjMzuirMgXhbzK+Oz7GrA5PYZ7J8mSDuifqEBx/ufANtdBu3Ebu5rQjaPidicxxvQUty/4vxAUNBDUCtFDJqtpRLGe0yfTEAUmhP83YPTmvqjWf4Hkj56MnH5x9ICvf3ZWjl/OIM/neLFUALIHsz/IqW0wrjoS+hb+GB2DUWjVv4jvE8oQknjWjfj3vn0OY/T19ZEsz6SR2QfP6FIRhcM0JwzLwdG07V40SVdPqhuhPeqkaPXwQvZoai/HzyePNtk76lD60PugOPjX0K59CczWj8PRBqroigwq5YVfc8aARqNBk8NxwivJMjDdpI6pcoZN2+qplUA3LqG6FRYvDbPFlnWzdvw4+aA9wUigsrwF/e+5CAqVy6E1/Xdgth/zex5RwikqBQ/f+epX6E73gajX7bRn0vBpmiSmyPmoEHDcuIbFQKGDRe2uwt3uTRW/6Tvr8lznYaJcJSJ+Yo7thb63Xp5Jvi+D89FYc2+m8wcIZ6ycGAXA4B81YeC8K6AweC20pm5GpljlsUGsAiAeVcQwBvoNm3fvdowTpkoChmek+5HIGL0UmVDu3jmzvlmugCRkF2kKKNS/L77x2wclkjp41oX8dbC2DZffm+n81XFz38sUhi7vg4HTbwGteAbUR38fn/LXfF6FD0Q5VUqn7aiRgCqJMjrddy3ofahMkXfWtipfE6AgkN3XV13aXun79djynj+vkqkiKK4sQv+pbEpqHzRGLwNq7own+rjkSYIRigSxKYcT6LcxsrmkeV1a6toaJGZv8viqSxj3pL3RQZH3/I3DbBi+nEL/ktuAaIPQGv80UGuPeNLDhkVWlUKpsgvcpiZ5cIv/KYur6rqrE2JQe2GKaHnivtEE5qh3mZB6I215z79wtA0LrjsRBk94DMGwG+r7PgyW+Vq8hSmGjiayBfGpHvm7Xbs8VQLRpk4YtKxyaIiV01km1NB76M9Z4i4jokwmKE8TLHCfcddD8Ijr0IlRMMf38VB8XkixecOaOLks8sbIQigML4i8y1nPv/wWC0Y+cjyUF34GOtM/gvb03ZCqcUmKYRbFJOK7J55gmbZE8y4cEh820DhsdzcZxg2TZ4hzxIHNEIwZZb1n3aaefwJ23XtV/iwpa2mk5XvSF/zpP8D8914aNjTtbOdfOQfv2YpTEBRfBbP2MLSn7nUgKSPFipMRimt3oVLwsqa/eTscSItbhMbl4NoU8fGMJBuj3WPwyELBvPLdhrnjfpNFfvDdHRh578egNP/T0Nz/V2DWf+YFrpS6CTceEQWOnF4KDtOmbi6L12NUeCeY/PUYWZiCpERSbDGovWxaviRnz/UUeTeWOB1aQaF67segMHAJ1Hd9EuzWCxAduTq4KkWU82XxbXzvvB7DPgRMEfagSOygHgzvI+s+jrrlVy6QZBX15HOrYOKnX8gcMMtzfFKiMPKHbRh86zVQGPogNPfdDFbjBQDiTx9E2Zq+KGYWlRL8PaqUWt3zSCA9A6FOOOrO+8jene7g1GJI+u9VfmBJOApa3/BiZvnDcrCTPkBh3kcGoHral0ErHA617R/lCbFYQ5NCysCnqJRQ1JPA+BjdnIExwqok66TmJO8jy5PMmpsemUwpmQ3FbvZx0ORptkE15lOY/7EFMHDc58Du7IL6zuuAzzaPYgU4dCpl61bYDNmuOlzBdWiYwttYnKRqGF2rAdVQ7GYfB1PeyiBfXGzDvA/2wcDxt+LDU4fW/m8Bd/1ItJwPHCTm712qlLvvCQEjLUnvqHgK6f/xjrX43wwPc2tAc/43XDB6UgFq8Oj1lk97JMrHWbDw8rNg6LSnwGq+DPVt1yJjjGadfhpJ8mFmTgl8id/jcO157HFaj8FvSnY148aryfXurHdegGJb3bK4E8RKKHLJso+DJZ+kSfrPQPXxvt+B8hE3QmPn56Ez8S/hjFmcLXEIVEq7HRnxhCQVksvGkBOMu2n6QYV8hXRfxXWo6iEOnjy6ou9AdXvhe6C8+K9QdfwAOuOrfANHaXwsJwQOQhP+HohVJKiUVjPWVYUIV5Xm8kp6YQopz2e9J6AqCXDuk5oCyri/H3J52oaZV1fC/N/7NJQWXga1jR8Hq7bGm+Plq8MIgCOjdxICB8nmpdRqsDFm4LNFPmkKKGhPoCBg/3/KFNSchNorV6BbeiZo5WNg+qX/Bra5OzluNYsq5cABPvOsq5BPoB7DUgbVys0UUfIO8JzJR2m2FotIys9qmDzNbptNeXd6eGsXTL34bgTECUAKC6Gx/VZ0PPakTjqlMgNKEwxNGk8nNHTiJNZYfWltYvIsKuoZZgx3vQzoLncSJZ9aWBjhEnb7pM+mvFVbD9NrL4Pymy5Dj2M31DfehONoe/YEROQxaIy9EIcBCun2CIlxYZ1pG+aXb6M7MtjZ0aqEfc3iDMOiP4MMXkEXqfck+aTd1Xuct9Gh4Ju3cSjlCWyA6f/8OhjVt0Jr7/0IkhcB9BI4a1HIxD1lc0UD8YcAEgg9NCpFiHU6sGPrNjC7cVW5KpkwRT0GOAkxtlxTnlYI4257pBT5mNPg9RgioshS1wXRejS1D4CyFWTqPkW+76QV0eewfV02+aNt0Av/CFpxMeJgDKjNlo2YJxb9YSehx5t3s6xSOu1MybNYdWIMiXqMbiKaaj1GmnwcPHUCPRXpAGRP3WsDI9HAqE2kyg+chKrybIuzgjm1mk18xd86nZeJnI+pQXQBb4zBeShVSqPpi3hmqvMM2RiycDefTWHyiGaSTZLVvujVe7Aypu71/uFY1kqSHzrTgsGTHcOadsb9k3PV8v5AwYzdps6D3HGc1GKVBnv+HzKVMjXlMgaNiV8kRz7rPdZjZGGapDNgg9prPYSeMePZ9+bojn+dDb+MlTEGKHQmCYw9a3AzYvii62Dkbe8XB6465c74vu6mM8BsET5Vwmw610XFzH9Wc1JdasPSP+qEaCJT4IvEgyMu8LVvH2zu1lXl180yhhbNLuK2XMyQZfXtliarkl63LPsozj88mjEmt8QbpjOEv+RWoWeAMXK+0/NDvGy0MVpTDigYCFRQsHetDHD0e80MzJAe5s6qUn612k7LqiYHuA6VTZGVMSjN3lQ/dv5rxn3o8xaF3dTd23IdX1d+LEHBX/iZAYKdogSENLqPvrjDmSd+gA+uSmH96P/u7+mevGAI2RhZnrgsNkUSKKbN3jq5qXGGbuWrEUU67bF9uY8vmUL9bAdut3x4559mw/AJMaDoSqWk5Vp4neeWXknWiKWzHmyKkCHUQeOth1YIao1mt/KLzr0iesB3bMh1fMv3ZNLY6DQzOssjFBZfYMZ7KV2plHjWkPKie06aCnH3iNdBSQB1hmwgTRPAMdzDDDX228GCM3+1W/tADX51sw8mP7DsHZF/m173bK7j6ymBJXn/WIzv6OUmXzLV62VBI6YHdKNSNICEDFQ3UxJDjCEW6gtNEgoCRK5VTrvM7dQPUn+MbvdRPf2dkd/XXv1l1/053IXl0IAnir/KPh1+vgl9C6iYHqzMGYy6gRlUioUeT217Caontpy4ScIoT0y6qiRjuC0i5pNlcGtW/gXs5WZL/ZzkkqaEVztqRLKLfeiLz4XK4W+ONDytiS25j+9bbVCAwummSoBN4x45Ae2KZSI8LkOYkVHN6HOnEYS//ccV2PHQAmi16Zq45Jl8bdtBN2X0A2LvqCazn1TQXLAsr9ZlOZ/8r670n+pmVJ2IJIFsle/R8kf8/g3R7uvIYbDow1/r+vgqODTCeo9RZAm0Z843lTwADeySuF/FH9Zfurfj0SJMvVrgaxre/n17JTqHu5PA8dCqEDByxx79FSgBmqv1aPR58qQrWLTdPprdwYLJ9w0vhfnnvDvafS1X4MgPXg0n3vp/oXjUeZmOL420IGtwvdyHKuRiC2SxGqU0hrxJKrHLXMreZwwY/XXJHZ8vf8fe9/Qz9JMsdBLJ0DaM/ugBOh0BCppDc4NBrKZrY/DUOXoP7Nprolw+j03BEnLDwvuoK/I0Y4tUtQ9mXB/Nmc3hFkmt0Z2x8os+8JnIjn2+PAi6scu+8BDsevoh2HvP1YnHn177bKRHwjTtwgtNMPpTphLShMBU4CaNrzdg11P9fFFeW3RLZb/642usF1c/pv/F8ceSbwd32naSZ10ZnH5gmC1OHOqgzuCgDuTsmaXKyxpRAAUUKdFRr+MuKB13w9v6z709EVSqfOUtK+Dw5ZdmC6sjeI665FJYcMY7YcM/fhbo+kcijz+5+h7+Cm7zzkOVu0hphhUV1IiYrBznpUxt0WHLvwwgJixe7k2QeYmnYujZ77Me3PIrY9nIEFyngqPTjkyexbmqzFONXneVakVo2B1vUC1R+NstKCwVFNkgygdVNldFN6kABPLk/qPkjeoSOPaqL+VWf31opJ72P++DxVd8L/PxB06xYOg4OzAESq+KWLURfZ21XQQ2/WQArI7N21MoMFKPYF/wIesLzRY87fMeG7zOkyYkzzIxhjYFBgwK41kuV+VcF8lWj8H7a3gr87jyGX0jltksayRWp6e9WBvnKPljb7yLD3LU9vJtn4Jdj9+XeGOOQKY5+faXoLJsReLxi8fYcNjpdjQAINnTiPJSGgcIbHhgEN1ThIHV8ceYiCvJvra276RtNEY/gUbpJgnE6RkODDsBCNlqPvsLRW7osFPIW+Mpy/lcpoiRl03mo3WZjBNQYf3nCXN7NoWUN4aWwNK/fBiGTz47+pzXroap5++B1354Nfz2a5+C9vho7P6Zi3sysseRH/9etPpZiB7PuVYCWZPoJyPCA+HAntLglQeq0K5RsMy2ElMiajjcVl4WGqNjz/+GfhSdpxm2r127aRAYcc9nehxjBndY0aO8JpLMFIU0pqDKAuJJ/TGcNdTyMAUDRVknPnkdQXHSLQ/D/LOju/FZzTpsumOlK9/49T3wn595N+z++cOp7HEKsofquZARG46+AA1CDaJnjeVRKSxWMq3B+vsr0J5AM9NsK5aIF04V4LBFZN59Lb/MWrfvAHycEfDt33eBob5ojEqJBwaLM/DO9ywQpPaLtGn0hSjeC9eH0qZIKE9Lmj7g9MfIzxTlAFMMnfNncMadz0UGslzD9SsrwZzc7JNvTGyC7d/9E9jwD3/DgZPEHqd+8SE4/CNfB1pFULzLdtzSCFbIpFKUJ8OsE3jlwQo0xvBBsjr+yIG4NcyEEu0brAA4mBFinXi++ejkFFz51L/TRgwochRXMNeb1WNwXU84MCwa8AaIP4wrDU2qhskT4wpO9rF64afiKStXF3/bqxHF664MHQdHXvZFWHTBikS5Lf/0NaitfSQkXxQRzbGn7oCpNY/AUrRNhk85O9ZzWXzxu6APBlFmMrrJGI3JqAW9FNmctUFg/YN9UNtHfcVS7BTdQjHuuRDplaigsNUsxpvPMe8H/zqqJCHMA6mqhElbQtfpJD7g5fc+vDD50Ps/C5WzLw1Bg0pGOOrtsOgPVkaeAItBZDY0cVDLmtcycfGKm+GUr/5bKig2Iyj2PvL5kHwB/Oqvg2zy8ucvgu0/ibYpzImXYOLp5XizJgMGZfzcjiSV0kGmWPdAGWp7LB8oVAKVbZfYd00nt6uCIviyIoATxRyQ5Kq62VX5Mm3ilskFWWOibbrzRuqBGtHqOy6BCq91uNNxmZQglNbXD+UEeq9t+k1G9eHVQ/Sfczkc88HrYXBJ8uK8TDVse+A7sA9BkWfeyK77/xImf/tzOOHGO6E0ssAFxeRTy8HuHAj3uIhhBUoj0ujiJx0k/HU/KUF9lDGq7S1FIfAjn1hdfMdab4/oBkQMeDBeFjfXLc80H/9CNhbuk8X82ZCb1OtH5DJFzLyR+qv/IYAh9PGSbKspt9AjmFmXvsIQW+9jYN5xMP93L4PF778CB+uwTPt+5Y7/DjXcf3C9kCzV6Oy8fvs/1sKxV90OQ0uqMPX0B0KgiIpmZlEp7Rk0NB8pQm0/AoKGA2GSISQ4mgiKoXJB2hhBFojKWwaBQiGwRHcqMIL2kcMalKd2bQGOoRSborN/V1e5lJ2P/jD1N/3LVsDxv3cljJz69tTQthtKfmk1bLzDMTTZJtcL6eRcb4TJ7/jBCrDeWURDsy2e6rCt4IW2w2n14IoAzUkd1j9agMa4HxQ0AAoQ/UcZY7D1XjS+BpsNQVBIdUC8vL+tnB2JcZIzMEYE3OSCnDSQeo+r3Ors25YbFPtXPw17Hv58dO4CwbDwoo/ByGnnuVSeZWOqY+MPb4UDaEjG1lPkMHT7F1F405lsAFuOl0ZS8h40+g8SOPUDGqx71IDWjO0DEFGa6WgiRG5owugU3ghbQ22IaD53U7URRBWWCo44tUJzMYZawcUMUU1hjXrKvJPp5+9z7Yss256fPwKbv31pLChOu+W+3EB77af3wa4Hv+KyRBQo8mxDR1FYcDLeA12hBYkIQmNURbxKmd6rwcuPGdBuepYpBa8VpSYAwueziQ+cMYjjkvfrRFqldhAUMeCI8kwgClSpjEECrOG4hw4okjY2R5w9rXFUz/5W27kVpl59Efb97G5o7Hgudl/TqNu3Pvg9OOZDV2dmnu3/50vQjNln7hlueBPmH2/DyDFysKnvhkQmvVJUytg2DV55UkcbxR/RkYamDGK5jCEAwdeIp5QHD0kAALFp02hwhH6TizH8OQw8KVuuN5J6L+GlPzvSreuUa66ycvsiT71TL6aRxfZAr2DeGedDdemyWKDtZilyBFkzAWR5mYLVZy46BQdigVQN1M8GLgCU8rug5ggAZ896DTb/uxZK00t2ID6mEKDQnHqPtmAK4gsppQ9qwO7IBYhIr0ROJnJS52IBehrNnH5gEGBr/42ZHegznJWNGCgKCApbAUUel3T9d/4c3nbrQz4Wmtq0DvY9uwr2xtgmqnxeUBTxMIchKEoDHm+SICFH9eyObSpAYNsaDV77TTiqSwK2igbSjnBqWAhnCif35B6WAORsgJwLCLGqJAiKfuF9EBp/D/zBLxPmGQXOFJO2KQw9PyhoikuqupQUmWDHqn+Cw85bDvufexxGn3kwkR26cUnlNriQwvyl+KQW+YxTNyBF1cU0ghVWCSqFlVBs+IUGo1ujQaHaF5oY8A512JmpD5N60Vn3d+x8ZnEBF7LuE8fT8akxqIoTli6p+qBoKaYsa+46JEAl5dnFNXjlUTpfuGFqdoNAFN7myZ10Kc8uc94SBMYi4MY2WzudSJeM07ozCZloio2vzmqXv1G+azeR7f5Ng5kD4Tbx7rvCEuydheYZOzOmsAjl1yIP4fwGnQG9AEalCqf9703kkAAhOK9kyjK99UpiXFIaY3iHmEaRN/BuDuCLrULcolamQe2qE06X8uUBNDKXUij0CVtC8ztzRPUjaYL3odDp9CjAyz/XoV2HVFBIdcJA0S9BgZ/LRAt04yHwemzGoG5wozuuFULURCQaYIqoMLk7AMTAwdKhzpapDkwYaiq5i276Y7S6kGcYGj6CQnUR4a6obB3HsSHtSZ+Tp6gUEq9Sdm0A2LpGh2A7U9VuBSXvoRHnnCu8whzVBzjX4kuzw+u38UddDmqiIRM40ckOgkJMW0yTZ5c7QApI8xYCxBLLbnZvKKo2RR75vkGAkSPR0Cw7o0lcCqWuZ0pIdBgozqZAcwo2/JrA6Jb4dVXVELcLCtu5foLnzUBRlDW2xFvhBfJEpA42MBq2sy4qzdofA893StoUIneSdYaaATraMjqMmu2eema1WA1JDvkCGpXDb0I3dMizF/ibFvNkBiMAEaFunsOYAVj7DKvpSAAFCagRCQoe5gauPkrSpiAeq0TNCJxNcBhlomfuw8l+N6OoDwaqfrFYb9aTZupngVHkRum43e6RKWjiaoXMuBxagMblPMqLatwbT8CrvJJ0wNaGJREGleIvqiplH3ocr77AXBAtkSXUqCaLU7BiZQYKGdGU9pHKVME0KYXZp4zM/THYeTGmqAqmaFJl2qJAuU2TZ82r3guzL+ZrJe6mSfWSFECThibXw7zIBkEhqqxJRKCqOgLAWm6xz87EIOeHRPPGWosJX7pqI8KmwEuAzS8S2LWD4s1LBgWhXiSTex+2E8XUBajLhLjqS6boVYah4AGLbaz53awBI2vKbVKAgve6YMtdGVoo06iJC7QDVWAkwVA18FEexFcrwXuhiqHKVYmYDEQDwYFCgcLAMEB/1WELoinsQPyBJRK46yQYyIoAxdQYssQaAjM1m3tdNMHIdANZMk7Bpi/qGr9HLKLpVLYTN1cSlfFS/z3t1WPMFmOkQ2PSlFMEqNsrgnWPMYhabSSMJg14PYfTXcYZPK/yiyq9JqjvpjKVVsBXg3ZCfccdl9SRZxWRJWWCNTtCpR+gMog3uwJu3EHV1867F8aWIGAT0WUYwsmHKEthK0zEHtTtLxPYvdV56g1F/UWqDiXvIYHQzyOarEDTAQUoCbS4/JsHChuqxcLsq5I0xqjKegx1QRhWmsaeUqAeOJQnko29gf4f44ARHEjWBUFOMbBj1A273f3ce7F5/IMKju0THk+bNXLjA4Ds0ccWsCdQ7hf1kcR7gWrIaeqx/DmO4BrobjmWkv2cHAXY+BKBVt2hf4OQeNUBftXheCAEKuKPDBSS6bSo7rCEBBjD+bdcjLBhW288G0PtKiNj9+z+dVBtFBAAvpUMlSeVHYAYlD81IwUClk2dPlWUxPrqzCA1SBFlLOgQC3Sd8h2NlAgUS8BfEFQRGvH6RmjhtkShwqtgQjqQnO60Aba9SmD/TghNm4xiiSAoNAEKTVElJeJXHVHvEHJWPVU6qOmzDIwUygiuB+ZTwwwcFoJDp66RFIz0sZta0hzaLxjyaabCHpFWt6xBcDicGY0a3kWNdeMRtSGEKIOugM8LTxMvSgWBolppTqgBCRqOUbBz2rODwI7NTn2uCgrVEExSHTI+IutnrRhQ+MwaQmKb9bVZSKBgzL4qSWSKpEXmFJC0LYc5dC3QKAxHvqiF1/si0h6R3oLMSxBv4EH069BBztaiPj9A/V0kM8S1B6KBJS0FOCcPIEtsINCoe6ISFFEsAREsIZuoyOswpTyJ8oQUhnD7yRIfkFnGtY/kCwkccq/EbWWQEvCST1qb1YsyVaA5V9myGVMQnx8eXl3YcyV96QF2I4lQUYqrCSpwIoNTIpJJAgvNBau2FdUxPQGwcxuBqQn/ZclWCJGqQ0RONV8tBVEYwwFFSYtWmQRIBHsQxUMhaGc5oKDK314XxpDeRxamCGfnHPkq6Nx+YP0c2CI2NLj6HwkkqsAbMJsPKBG0Tr1JL65d4A16bDhQFLm4AavA79Ry/9o0hde2IiAmSciOYgm5EiGhXBYJMIN001lavCUSehrxgm8QMYWARHMGP75Tg0E4U5RFB5YIYpw9YPhAkbOTDlHlWZjcdOR5S4Jg72yb+iuNxSwri3XEE60MbK4+YtK5PChEI9c1l24n1WJWxxa/nRonsGcXvk96KVX1mjsykKYmvhTPw3mnPgOzjtfVbzgy7LpLerxxTSKMzLrSfailxGxcp5zMtipBh2HCsouqS1rJudyVCireicdwqrHZVATECBi6AxBJkZqt1DDg301CebUXnwRNHZuCCss2bj3RYFl+yOgJLI3NYhEH9qKXga9WSx0g6rrRnL5FzISGgOCoD2lLAGcMIiYDocdgeLmbUqBGM9YzEu/s+NIlbbkxG/+vOJOyGe2zBYxap7N5uGCcZKN/1k2j1SDTyOWu1FIG5rWwxsAcIIIKuPdhO6HtklA5zE1nrMGeeJahZ14JtalrV1BNaZ0svqfES4ZRwRj8t2LC8fg4wOh+x6C0w0uow4xF3UFpS6ZQDUjBDI4KIUraXKgfWza3dRq5uUyTgWcJOOUOg+L4TnRXj46ROOpx26wBY8Aij1u6flK92QUoRCuEoPohManqtknwJQHCqpVsXiPKG7NbzndUVGWzwbZt8aRIT0fM7ZDK3VU5sorbWdkHxlBVTE4R1o/KV8gcZJ8Z0bGYyOiqroteFFRhCuLaFV6RjQPsminkhaEdN8E7jjGY/IDIHbVElls1PuU/+D4ZeNrWk7OnSurmDxoVegMOqn4wQBFidYXyhQmB7EFgtOnIWx1UHxoyTUGoD2ZDoFdDbI8J/MtXCzuCOIZqE4E2NuPMGm+yZSFsOeOGunGHqGKjGdRxrGMxnyxsMftA94FBygYjmdLu4PI4qFyVBAY1i002zUFluCF/JyFJou0mx/C2UGfdNVvAIFvePwKThdJ37CJcx9RJbvWR0XuhSkqZ5U6qIonGbBLWHNYWf2T40liwTPMGhWheN3/EIIy3UI+jXmF2Qz1kqAWPR0M3eYrlHgyHYpqyYEZxPT36lp6R54EQDiqLgwoCyb2s2wxnCoWpNC0EKjXcpReKQNrw3aOvnLjeO0HHiF9wcfvQAIP978WL5xfpoL6KFrT3pIGjF5eWCvmq7hmqfSJLaSttH9X21ZT6QTXFdbIm6kE8+bi4Fg18O21SDgrnSXcGJTjHQ41eqoCRWc5BQxOgEE3hYjznqG3adAxVBxSePInhGo2BomM/pc3Yl5z5xIH2rDGG/PDCRUNFGCh8A5X+tRScx5EG+n/3AgopX1Xk+5R1TeXAe2t90BBAXHkq5DWxYmEgHgJRrRzwy2khzwdFzuGI8DpAMTKDqW8pX1ee9KzblHL9jYA8UQwhbmg69o6tNa3vQ61z01ufnGzMZoArBNMXLh4+GcFxJS1py5HDl+AvCiCe1KoefVGZbkpA3qVfGuy+E2YL9s6ZQhh3DepUU6vyoEBELXyRV8j6hA0KO6glCmZ8YW0ZrBIuKAkG7/D4w0ImDyikbZPl/glbrIb0uRVdpCehYd511s8mXoLXYft/AgwAc4nVvvbk12EAAAAASUVORK5CYII=" alt="zhi" />
							</div>
							<div class="commercial_detail_infer">
								<p>马上使用58置顶推广，帖子效果可提升约 3~5倍！${this.isPackage ? '' : `<div>置顶页面<span>置顶将在${page}页面展示</span></div>`}</p>
								<ul class="commercial_detail_time commercial_top_time clearfix zl_common_allHour fl" data-allHours="${data.maxSaleHour}">${str}</ul>
								<div class="commercial_detail_price clearfix">
									<p class="commercial_detail_amount">
										实付金额：<span class="commercial_realPayment"></span><span>元</span>
									</p>
									<p class="commercial_detail_origin">
										（账户资金：<span class="commercial_account_balance"></span>元）
									</p>
								</div>
							</div>
							<div class="commercial_detail_sure">马上置顶</div>
						</div>
						<div class="commercial_detail_top">
							<div class="commercial_detail_transparent_bg"></div>
                            <div class="commercial_detail_resure">
                                <p class="commercial_detail_toptip">提示：<span class="commercial_detail_close"></span></p>
                                <p class="commercial_detail_remsg">确认开启置顶吗？</p>
                                <div class="commercial_detail_reoptions">
                                    <div class="commercial_detail_rright">确定</div>
                                    <div class="commercial_detail_rcancel">取消</div>
                                </div>
                            </div>
                            <div class="commercial_detail_err">
                                <p class="commercial_detail_toptip">提示：<span class="commercial_detail_close"></span></p>
                                <p class="commercial_detail_remsg" id="commercial_detail_err"></p>
                                <div class="commercial_detail_reoptions">
                                    <div class="commercial_detail_rcancel">确定</div>
                                </div>
                            </div>
							<div class="commercial_detailtop_section">
								<p class="commercial_detail_toptip">您本次置顶余额不足：<span id="commercial_detail_close"></span></p>
								<div id="prompty_price"></div>
							</div>
						</div>
			 		</div>
			 	</div>
		 	</div>`;

        // return detail;

        $("body").append(detail);
        // 填充价格
        _this.fillPrices(data, true);
    },

    // 填充计算所得的还需支付价格、总计价格
    fillPrices: function (price, tip) {
        // 发布页总计金额和应付金额
        var $amount = $("#commercial_issue_payPrice");
        var $pay = $(".commercial_payPrice");
        // 详情页实付款
        var $commercial_realPayment = $('.commercial_realPayment');
        // 详情页账户资金
        var $commercial_account_balance = $('.commercial_account_balance');

        // 房产新增的会员咨询提示
        var $hyt_fc_aftervip = $('.hyt_fc_aftervip');

        // 每次重新计算之后都更新window.commercial的数据
        this.getzhiParam(price);

        if (tip) {
            // 发布页总计金额和应付金额
            $amount.html(price.hidden_totalPrice);
            $pay.html(price.realPrice + "元");


            // 详情页实付金额和账户资金
            $commercial_realPayment.html(price.realPrice);
            $commercial_account_balance.html(price.accountBalance);


            // 发布页房产会员提示消息
            if (this.type == '10' && price.afterVipPrice) {
                $hyt_fc_aftervip.find('.hyt_fc_afvprice').html(price.afterVipPrice);
                $hyt_fc_aftervip.show();
            } else {
                $hyt_fc_aftervip.hide();
            }
        } else {
            $amount.html('0.00');
            $pay.html('0.00元');
            $hyt_fc_aftervip.hide();
        }
    },

    // 获取库存数据（发布页和详情页专用）
    getStocks: function () {
        var _this = this;
        var pageList = JSON.stringify(_this.pingdao);
        $jsonp("//infotophttpapi.58.com/inventory/query",
            $.extend(true, {}, {pageList: pageList, productId: 100, source: _this.param.common.source, type: 0}),
            function (result) {
                if (result.code != 200 || result.errorcode != 0) {
                    return;
                }
                ;
                var data = result.data;
                // 详情页
                if (_this.type == 9) {
                    // 默认天数的折扣
                    var defaultDiscount;
                    // 处理一下hours
                    var hoursArr = [];
                    for (var i = 0; i < data.stocks.length; i++) {
                        hoursArr.push(data.stocks[i].hours);
                        if (data.stocks[i].defaultDays) {
                            defaultDiscount = data.stocks[i].discount;
                        }
                    }
                    var hours = hoursArr.join(',');
                    // 调用价格计算
                    getPriceRequest({
                        pageList: pageList,
                        hours: hours,
                        accountBalance: _this.accountBalance,
                        defaultDiscount: defaultDiscount
                    }, e => {
                        e.maxSaleHour = data.maxSaleHour;

                        // 把初始化每一条的价格放到data.stocks中去，data.stocks的数据和e.initial中的数据是一一对应的
                        for (let i = 0; i < e.initial.length; i++) {
                            data.stocks[i].hidden_totalPrice = e.initial[i].hidden_totalPrice;
                            data.stocks[i].discountPrice = e.initial[i].discountPrice;
                        }
                        e.stocks = data.stocks;

                        _this.renderDetailDom(e);
                        if (_this.quit) {
                            $(".commercial_detail_sure").addClass("commercial_detail_quit");
                        }
                        // 渲染完dom结构之后再调用绑定事件
                        _this.domEvent();
                    })
                }

                // 发布页
                if (_this.type == 10) {
                    $('#commercial').html(_this.renderIssueDom(data));
                    $("#tg_iframe").height("0px");
                    _this.domEvent();
                }

                // 埋点
                _this.trackClick('ENTER_0001');
            })

    },

    // 获取置顶页面
    getInitPage: function () {
        var _this = this;

        $jsonp("//infotophttpapi.58.com/infoTop/initCreate",
            {
                cateId: _this.param.cateid,
                localId: _this.param.local,
                productId: 100,
                source: _this.param.common.source,
                entityType: _this.param.entitytype,
                entityId: _this.param.entityidlist
            },
            function (result) {
                // console.log(result)
                _this.pingdao = [];
                _this.pingdaoName = [];
                _this.promptyCitysed = [];
                _this.promptyCateed = [];
                _this.pricePerHour = [];

                if (result.code != 200 || result.errorcode != 0) {
                    return;
                }
                var data = result.data;

                for (var item in data.pageList.channels) {
                    _this.pingdao.push(item);
                    _this.pingdaoName.push(data.pageList.channels[item].channelName);
                    if (data.pageList.channels[item].vipDiscount < 1) {
                        _this.vipDiscount = true;
                    }
                    if (data.pageList.channels[item].isCheck) {
                        _this.isPackage = false;
                    }

                    // 设置点击添加优惠券的参数
                    _this.promptyCitysed.push(item.split("&")[1]);
                    _this.promptyCateed.push(item.split("&")[0]);
                    _this.pricePerHour.push(new Decimal(data.pageList.channels[item].price).div(100).toString().match(/\d*\.?\d{0,2}/g)[0]);
                }

                _this.channels = data.pageList.channels;
                _this.accountBalance = new Decimal(data.balance.common).add(data.balance.business).add(data.balance.cash);
                _this.businessDescStr = data.balance.businessDesc + "推广币";
                _this.pageList = JSON.stringify(_this.pingdao);
                _this.getStocks();

                // var options = {
                // 	channels: _this.channels,
                // 	balance: data.balance,
                // 	payLay: [
                // 		{
                // 			workLine: '通用推广币',
                // 			price: data.balance.common
                // 		},
                // 		{
                // 			workLine: data.balance.businessDesc+"推广币",
                // 			price: data.balance.business
                // 		},
                // 		{
                // 			workLine: "58现金",
                // 			price: data.balance.cash
                // 		}
                // 	]
                // }

                // 初始化价格计算并传入参数

                // _this.calculateMode = new CalculateMode(options);
                // console.log('_this.calculateMode', _this.calculateMode);

                _this.couponParam = {
                    version: '2.0',
                    userId: data.coupon.userId,
                    isDispCateId: data.coupon.isDispCateId,
                    isDispCityId: data.coupon.isDispCityId,
                    source: data.source,
                    adSource: data.coupon.adSource,
                    cateLevel: 2,
                    cityLevel: 1,
                    callBack: _this.couponCall()
                };
                // 非发布页生成新余额对象

                // if(_this.type != 10){
                // 	_this.newYue = new NewYue(options);
                // 	// console.log('_this.newYue', _this.newYue)
                // }
            })
    },

    // 创建优惠券
    createCoupon: function (data) {
        this.coupon = new window.Coupon(data);
    },

    // 优惠券回调
    couponCall: function () {
        var _this = this;
        return function (coupon) {
            var price, durationHour = '';

            // var msag = "<span>券</span>优惠券抵扣"+ new Decimal(coupon.couponPrice).div(100).toString().match(/\d*\.?\d{0,2}/g)[0]+"元";

            if (coupon.auctionType == 2) {
                price = 0;
                durationHour = coupon.durationHour;
                // msag = "<span>券</span>已选择1张时长券，延长"+durationHour+"小时";
            } else {
                price = coupon.couponPrice;
            }
            _this.ticket = {
                price: price,
                type: coupon.couponType,
                coupon: coupon.couponCode,
                durationHour: durationHour
            }

            // 价格计算填充
            // var pageList = JSON.stringify(_this.pingdao);
            var hours = $('.commercial_top_time .commercial_item_selected').attr('data-hours');
            var realHours = _this.ticket.durationHour ? (hours * 1 + _this.ticket.durationHour * 1) : hours;
            getPriceRequest({
                pageList: _this.pageList,
                hours: realHours,
                couponCode: coupon.couponCode,
                accountBalance: _this.accountBalance
            }, e => {

                _this.fillPrices(e, true);

                // 填充优惠券文案
                var msag = "<span>券</span>优惠券抵扣" + e.couponDisPrice + "元";
                if (coupon.auctionType == 2) {
                    msag = "<span>券</span>已选择1张时长券，延长" + durationHour + "小时";
                }
                $(".commercial_issue_ticket").html(msag);
            })
        }
    },

    // 点击成功后的回调函数，用于发布页
    successCall: function (result) {
        // 发布成功
        var text = '';
        if (this.type == 11) {
            // 余额不足
            if (result.errorcode == 3 && result.code == 200) {
                text = `<div class="commercial_tips">
							<p class="commercial_title">置顶余额不足，<a href="${result.data.redirectUrl}" target="_blank">请充值</a></p>
						</div>`;
            } else if (result.code == 200) {
                // 调用成功页
                text = `<div class="commercial_tips">
							<p class="commercial_title">置顶成功,扣款${new Decimal(result.data.orderMoney).div(10000).toString()}元</p>
						</div>`;
            }
            $("#prompty_price").html(text);
            return;
        }
    },

    // 获取支付提交参数
    getPayUrl: function (price) {
        var _this = this;
        var hours = $('#prompty_time .commercial_item_selected').attr('data-hours');
        var realHours = _this.ticket.durationHour ? (hours * 1 + _this.ticket.durationHour * 1) : hours;
        var url = $.extend(true, {}, urlParam, {
            hours: realHours,
            type: 0,
            amount: new Decimal(price.hidden_totalPrice).mul(10000).toNumber(),
            waitPay: new Decimal(price.payPrice).mul(10000).toNumber(),
            pageList: JSON.stringify(_this.pingdao),
            couponCode: _this.ticket.coupon,
            payType: $("#prompty_price .zl_pay_mode .icon-sanjiaoxuanzhong").attr("data-check")
        })
        return url
    },

    // 事件绑定
    domEvent: function () {
        var _this = this;
        // 发布页'置顶推广'选中
        $event($(".commercial_content")).$on('click.wer', '#commercial_issue_select', function (e) {
            var $this = $(this);
            var check = $this.attr("data-check");
            if (check === 'true') {
                $this.attr("data-check", "false");
                window.commercial.selected = false;
                _this.trackClick('STATUS_0002');
                $this.removeClass('commercial_issue_button_checked');
                $('.commercial_auto').attr("data-check", "false");
                $('.commercial_auto').removeClass('autopay_checked');
            } else {
                $this.attr("data-check", "true");
                window.commercial.selected = true;
                _this.trackClick('STATUS_0001');
                $this.addClass('commercial_issue_button_checked');
            }
            $(".commercial_issue_ticket").html("<span>券</span>添加优惠券");

            _this.ticket = {price: 0, coupon: '', durationHour: ''};

            // 价格计算填充
            var hours = $('.commercial_top_time .commercial_item_selected').attr('data-hours');
            getPriceRequest({pageList: _this.pageList, hours: hours, accountBalance: _this.accountBalance}, e => {
                _this.fillPrices(e, check !== 'true');
            })

            window.event ? window.event.cancelBubble = true : e.stopPropagation();
            window.event ? window.event.returnValue = false : e.preventDefault();
            return false;
        })
        //发布页自动续费
        .$on('click', '.commercial_auto', function () {
            var $this = $(this);
            var check = $this.attr("data-check");
            var track = 'OTHER_0001';
            if ($('#commercial_issue_select').attr('data-check') != 'true') {
                return false;
            }
            if (check === 'true') {
                $this.attr("data-check", "false");
                window.commercial.autoRenewal = 0;
                track = 'OTHER_0002';
                $this.removeClass('autopay_checked')
            } else {
                $this.attr("data-check", "true");
                window.commercial.autoRenewal = 1;
                $this.addClass('autopay_checked')
            }
            _this.trackClick(track);
        })
        // 购买时间选择
        .$on('click', '.commercial_top_time li', function () {
            var $this = $(this);
            // 发布页如果“置顶推广”没有选中，则直接return
            if ($("#commercial_issue_select").attr("data-check") === "false") {
                return;
            }
            // 如果当前项已经被选中，那么不执行，直接return
            if ($this.hasClass('commercial_item_selected')) {
                return;
            }

            // 如果置顶已售罄或者不能购买
            if ($this.hasClass("zl_time_quit")) {
                return false;
            }
            $(".commercial_issue_ticket").html("<span>券</span>添加优惠券");
            _this.ticket = {price: 0, coupon: '', durationHour: ''};
            // 改变选中和未选中的样式
            $this.addClass('commercial_item_selected').siblings().removeClass('commercial_item_selected');

            // 计算价格并填充
            var hours = $this.attr('data-hours');
            getPriceRequest({pageList: _this.pageList, hours: hours, accountBalance: _this.accountBalance}, e => {
                _this.fillPrices(e, true);
            })
            _this.trackClick('DATE_0' + $this.attr("data-hours"));
        })
        // 详情页入口关闭
        .$on('click', '.commercial_min', function () {
            $('.commercial_transparent_bg').hide();
            $("#prompty_time").hide();
            _this.trackClick("status_0004");
        })
        // 详情页点击“马上置顶”
        .$on('click', '.commercial_detail_sure', function () {
            _this.trackClick('STATUS_0003');

            // 请求价格
            var hours = $(".commercial_top_time .commercial_item_selected").attr("data-hours");
            // var pageList = JSON.stringify(_this.pingdao);
            getPriceRequest({pageList: _this.pageList, hours: hours, accountBalance: _this.accountBalance}, e => {
                e.businessDescStr = _this.businessDescStr;
                // console.log(e)
                // 还需支付的金额大于0
                if (e.payPrice*1 > 0) {
                    // 详情页余额不足展示扣费详情
                    if (_this.type == 9) {
                        $(".commercial_detail_top").find('.commercial_detailtop_section').show();
                        $(".commercial_detail_top").find('.commercial_detail_resure').hide();
                        $(".commercial_detail_top").show();
                        // 主要用于价格不足用
                        newYue.init(e);
                        return;
                    }
                } else {
                    // 余额足够，弹出二次确认弹窗
                    $(".commercial_detail_top").find('.commercial_detailtop_section').hide();
                    $(".commercial_detail_top").find('.commercial_detail_resure').show();
                    $(".commercial_detail_top").show();
                    _this.enoughUrl = _this.getPayUrl(e);
                }
            })
        })
        // 详情页二次确认弹窗点击确定
        .$on('click', '.commercial_detail_rright', function() {
            _this.submit(_this.enoughUrl);
        })
        // 详情页弹窗关闭
        .$on('click', '#commercial_detail_close, .commercial_detail_top .commercial_detail_close, .commercial_detail_top .commercial_detail_rcancel', function () {
            $(".commercial_detail_top").hide();
            $(".commercial_detail_resure").hide();
            $(".commercial_detailtop_section").hide();
            $(".commercial_detail_err").hide();
            _this.trackClick('STATUS_0002')
        })
        // 添加优惠券
        .$on("click", '.commercial_issue_ticket', function () {
            if ($("#commercial_issue_select").attr("data-check") === "false") {
                return;
            }

            // 价格计算填充
            var hours = $(".commercial_top_time .commercial_item_selected").attr("data-hours");
            var param = {};

            param.cityId = _this.promptyCitysed.join("$");
            param.cateId = _this.promptyCateed.join("$");
            param.pricePerHour = _this.pricePerHour.join("$");
            param.topTime = hours;
            param.usableType = -1;
            param.allHour = $(".zl_common_allHour").attr("data-allHours");

            // var pageList = JSON.stringify(_this.pingdao);
            getPriceRequest({pageList: _this.pageList, hours: hours, accountBalance: _this.accountBalance}, e => {
                param.topprice = e.couponPrice;
                if (!_this.coupon) {
                    _this.createCoupon(_this.couponParam);
                }
                _this.coupon.showCoupons(param);
            })

            _this.trackClick('COUPON_0001');
        })
        // 去支付的接口
        .$on('click', '.zl_submit_sure', function () {
            if ($(this).hasClass("zl_submit_quit")) {
                return false;
            }

            // 去支付的时候请求价格
            var hours = $(".commercial_top_time .commercial_item_selected").attr("data-hours");
            // var pageList = JSON.stringify(_this.pingdao);
            getPriceRequest({
                pageList: _this.pageList,
                hours: hours,
                couponCode: _this.ticket.coupon,
                accountBalance: _this.accountBalance
            }, e => {
                _this.submit(_this.getPayUrl(e));
            })
            // _this.submit(_this.getPayUrl());
            _this.trackClick('PAY_0001');
        })
        // 支付方式选择
        .$on('click', '.zl_pay', function () {
            $(this).addClass("icon-sanjiaoxuanzhong").siblings().removeClass("icon-sanjiaoxuanzhong");
            _this.trackClick('PAY_0' + $(this).attr("data-check"));
        })
    },

    // 发布页、详情页的提交回调
    submit: function (url) {
        var _this = this;
        var data = {};
        if (url) {
            url.productId = 100;
            url.entityId = _this.param.entityidlist;
            url.entityType = _this.param.entitytype;
            url.chargePage = 0;
            url.source = _this.param.common.source;
            data = url;
        } else {
            data = {
                key: _this.param.legokey,
                entityId: _this.param.entityid,
                entityType: _this.param.entitytype,
                productId: 100,
                chargePage: 0,
                source: _this.param.common.source,
                payType: "wx"
            }
        }
        $jsonp("//infotophttpapi.58.com/infoTop/create",
            data,
            function (result) {
                if (result.code != 200) {
                    if (_this.type != 11){
                        $("#commercial_detail_err").html(result.msg);
                        $(".commercial_detail_top").find('.commercial_detail_err').show();
                        $(".commercial_detail_top").find('.commercial_detailtop_resure').hide();
                        $(".commercial_detail_top").find('.commercial_detailtop_section').hide();
                        $(".commercial_detail_top").show();
                    }
                    return false;
                }
                var data = result.data;
                if (_this.type == 11) {
                    _this.successCall(result);
                } else {
                    if (result.code == 200 && result.errorcode == 3) {
                        window.location.href = data.redirectUrl;
                    } else {
                        location.href = "//zhiding.58.com/pc/infotop/resultZhiding?entityType=" + url.entityType + "&entityId=" + url.entityId + "&productId=100&source=" + url.source + "&adId=" + data.adId;
                    }
                }
            })
    },
    // 获取返回的数据，添加到window.commercial中
    getzhiParam: function (price) {
        var _this = this;
        var hours = $('#prompty_time .commercial_item_selected').attr('data-hours');
        var realHours = this.ticket.durationHour ? (hours * 1 + this.ticket.durationHour * 1) : hours;
        $.extend(true, window.commercial, {
            hours: realHours,
            amount: new Decimal(price.hidden_totalPrice).mul(10000).toNumber(),
            waitPay: new Decimal(price.payPrice).mul(10000).toNumber(),
            pageList: JSON.stringify(_this.pingdao),
            couponCode: _this.ticket.coupon
        })
    },

    // 添加埋点的方法
    trackClick: function (param) {
        if (!window.clickLog || typeof window.clickLog !== "function") {
            window.trackStorage.push(param);
            return false;
        }
        window.trackStorage = [];
        clickLog('from="' + param + '"&"' + this.trackLogParam);
    }
}

export default IssueDetail
